<template>
    <article
        :class="showColumn == true ? 'col-12 col-sm-6 col-lg-4 col-xl-3 col-xxxl-3 mb-5' : ' h-100 w-100'"
    >
        <router-link
            :to="{ name: 'Projet-fr', params: { slug: productionData.slug } }"
            class="card-index"
        >
            <div class="card-header">
                <AssetLoader
                     v-if="productionData.imageId !== 0"
                    :asset="{ asset: productionData.imageId }"
                    transform="?mode=crop&width=525&height=290"
                />
                <AssetLoader
                    v-else
                    :asset="{ asset: getRandomElementID() }"
                    transform="?mode=crop&width=525&height=290"
                />
                <div class="overlay"></div>
            </div>

            <div class="card-body">
                <div class="subject-wrapper">
                    <p v-if="productionData.surtitle !== 'null' " class="date">{{ productionData.surtitle }}</p>
                </div>
                <div class="subject-wrapper">
                    <h6 class="title">{{ productionData.title }}</h6>
                </div>

                <div class="subject-wrapper">
                    <p class="exerpt" v-html="productionData.description"></p>
                </div>
            </div>
            <div class="card-footer">
                <p class="link-arrow left-to-right bold text-red no-margin"></p>
            </div>
        </router-link>
    </article>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import AssetLoader from '@/components/helpers/AssetLoader'

export default {
    name: 'ProductionCard',
    components: {
        AssetLoader,
    },
    props: {
        productionData: {
            type: Object,
            required: true,
        },
        showColumn: {
            type: Boolean,
            required: true,
        },
        defaultImage: {
            type: Array,
            required: true,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
        getRandomElementID() {
            return this.defaultImage[Math.floor(Math.random()*this.defaultImage.length)].img.imageID;
        },
    },
    // On loaded...
    mounted() {},
}
</script>
